export default __webpack_public_path__ + "static/media/iconPolygonWhite.c2aab395.svg";